import React from 'react';
import SimpleGrid from '@legacy-vfuk/core-simple-grid';
import { SolutionsSectionProps } from './types/SolutionsSection.types';
import SolutionCard from './SolutionCard';
import {
  SolutionsContainer,
  SolutionsWrapper,
  SolutionsContent,
  SolutionsText,
  SolutionsCards,
} from './styles/SolutionsSection.styles';
import RichTextElement from '../pageBuilder/Elements/RichText';

const SolutionsSection = ({
  header,
  topicName,
  summary,
  solutions,
}: // displaySaveIcon,
// saveLabelText,
// saveIconClicked,
SolutionsSectionProps) => {
  const solutionCards = solutions.map(solution => {
    return (
      <SolutionCard
        key={solution.id}
        id={solution.id}
        topicName={topicName}
        header={solution.header}
        summary={solution.summary}
        image={solution.image}
        buttonRow={solution.buttonRow}
        // displaySaveIcon={displaySaveIcon}
        // saveLabelText={saveLabelText}
        // saveIconClicked={saveIconClicked}
      ></SolutionCard>
    );
  });
  return (
    <SolutionsWrapper id="solutions">
      <SolutionsContainer>
        <h3>{header}</h3>
        <SolutionsContent>
          <SolutionsText>
            <h4>{topicName}</h4>
            <RichTextElement {...summary} />
          </SolutionsText>
          <SolutionsCards>
            <SimpleGrid
              columns={{
                lg: 2,
                md: 1,
                sm: 1,
              }}
              spacing={8}
              verticalAlign="stretch"
            >
              {solutionCards}
            </SimpleGrid>
          </SolutionsCards>
        </SolutionsContent>
      </SolutionsContainer>
    </SolutionsWrapper>
  );
};

export default SolutionsSection;
